export const PRIVATE_PAYMENT_BASE = {
  clientId: '44',
  status: 'PENDING',
  details: {
    type: 'PRIVATE'
  }
};

export const HEALTH_INSURANCE_PAYMENT_BASE = {
  status: 'PENDING',
  details: {
    type: 'HEALTH_INSURANCE'
  }
};
